import React from 'react';
import './CityMap.scss';
import axios from 'axios';
import { useState, useEffect } from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

const rawApiUrl = process.env.REACT_APP_API_URL;
const apiBaseUrl = rawApiUrl && rawApiUrl.endsWith('/api') ? rawApiUrl : `${rawApiUrl}/api`;

const CityMap = () => {


  const [cityMapUrl, setCityMapUrl] = useState('');

  useEffect(() => {
    const fetchSchemaUrl = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/MainPageSettings/GetSiteSettings`);
        setCityMapUrl(response.data.data.cityMapUrl);

      } catch (error) {
        console.error('Error fetching city map:', error);
      }
    };

    fetchSchemaUrl();
  }, []);


  return (
    <div className="city-map-page">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-lg-10 col-md-7">
          <div className="city-map-content">
          <h1 className="page-title mb-3">İskenderun Şehir Haritası</h1>

          <div className="city-map-image">
            <img src={cityMapUrl} alt="İskenderun Şehir Haritası" />
          </div>  
        </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};

export default CityMap;
